import Link from "next/link";
import { JobFunction } from "../types";
import { transformQueryParamsWithoutLocale } from "@shared/utils";

export type JobFunctionCardProps = {
  data: JobFunction;
  index: number;
};
export function JobFunctionCard({ data, index }: JobFunctionCardProps) {
  const getFilter = () => {
    return transformQueryParamsWithoutLocale("/lowongan-dalam-negeri/lowongan", {
      jobFunctions: [
        {
          id: data.id,
          label: data.name,
        },
      ],
    });
  };

  return (
    <div className="rounded-xl overflow-hidden relative cursor-pointer bg-gray-50 border border-gray-200 flex items-stretch hover:bg-gray-100">
      <Link href={getFilter()} target="_self" className="absolute top-0 left-0 w-full h-full">
        &nbsp;
      </Link>
      <div className="flex-1 flex flex-col items-start justify-between text-left text-sm font-bold p-4">
        {data.name}
        <div className="mt-1 text-gray-500 font-normal">
          <span className="font-semibold">{data.availableVacancyQuota || 0}</span>
          &nbsp;Lowongan
        </div>
      </div>
    </div>
  );
}
